import { isSgmeErrorResponse, type SgmeErrorResponse } from 'apiConnector/reports';
import { isReport, type Report } from 'utils/reports';

export type DominoError = {
  errorCode: string;
  message: string;
};
export function isDominoError(val?: any): val is DominoError {
  const error = val as DominoError | undefined;
  return !!error?.errorCode && !!error?.message;
}
export type DominoGetSalesReport = Report<'Domino', 'Get sales', SgmeErrorResponse<DominoError>>;

export type DominoGetBookingParamsReport = Report<'Domino', 'Get booking params', string>;
export type DominoGetSettlementTypeReport = Report<'Domino', 'Get settlement types', string>;

export function isDominoGetSalesReport(val?: any): val is DominoGetSalesReport {
  return (
    isReport(val) &&
    val.origin === 'Domino' &&
    val.context === 'Get sales' &&
    isSgmeErrorResponse(val.payload) &&
    isDominoError(val.payload.httpError.error)
  );
}

export function isDominoGetBookingParamsReport(val?: any): val is DominoGetBookingParamsReport {
  return (
    isReport(val) && val.origin === 'Domino' && val.context === 'Get booking params' && typeof val.payload === 'string'
  );
}
export function isDominoGetSettlementTypesReport(val?: any): val is DominoGetSettlementTypeReport {
  return (
    isReport(val) &&
    val.origin === 'Domino' &&
    val.context === 'Get settlement types' &&
    typeof val.payload === 'string'
  );
}
